<template>
  <div id="Home" class="min-h-screen flex items-center justify-center flex-col">
    <h2>Questions</h2>
    <h2>&darr;</h2>
    <div id="questions" >
    <!-- <div id="questions" class="w-10/12 lg:w-8/12 flex items-center justify-center "> -->
      <!-- <div
        class="
        question pt-24 pl-28 pr-8 pb-6 bg-gray-100
        rounded-xl m-4 relative overflow-hidden cursor-pointer
        "
        v-for="(question, index) in questions"
        :key="index"
        @click="routeToQuestion(index)"
        >
        <span class="Q absolute -top-4 -left-4 font-bold text-9xl opacity-30">Q</span>
        <span class="index font-bold text-xl">
        {{index+1}}
        </span>
      </div> -->
        <!-- <span
        @click="routeToQuestion(3)"
      class="text-center">
            <button type="button"
            class="btn btn-outline-primary mt-5 mx-4"
            data-toggle="button" aria-pressed="false"
            autocomplete="off">
                Question
            </button>
        </span > -->
        <span >
                <button @click="routeToQuestion(0)"
                type="button" class="btn btn-outline-primary mt-5 mx-4 text-white"
                data-toggle="button" aria-pressed="false" autocomplete="off">
                  Question 1
                </button>
            </span >
            <br />
            <span>
                <button @click="routeToQuestion(1)"
                 type="button" class="btn btn-outline-success mt-5 mx-4 text-white"
                 data-toggle="button" aria-pressed="false" autocomplete="off">
                  Question 2
                </button>
                <button @click="routeToQuestion(2)"
                 type="button" class="btn btn-outline-danger mt-5 mx-4 text-white"
                 data-toggle="button" aria-pressed="false" autocomplete="off">
                  Question 3
                </button>
                <button @click="routeToQuestion(3)"
                 type="button" class="btn btn-outline-success mt-5 mx-4 text-white"
                 data-toggle="button" aria-pressed="false" autocomplete="off">
                  Question 4
                </button>
            </span >
            <br />
            <span>
                <button @click="routeToQuestion(4)"
                 type="button" class="btn btn-outline-primary mt-5 mx-4 text-white"
                 data-toggle="button" aria-pressed="false" autocomplete="off">
                  Question 5
                </button>
                <button @click="routeToQuestion(5)"
                type="button" class="btn btn-outline-warning mt-5 mx-4 text-white"
                data-toggle="button" aria-pressed="false" autocomplete="off">
                  Question 6
                </button>
                <button @click="routeToQuestion(6)"
                type="button" class="btn btn-outline-danger mt-5 mx-4 text-white"
                data-toggle="button" aria-pressed="false" autocomplete="off">
                  Question 7
                </button>
                <button @click="routeToQuestion(7)"
                 type="button" class="btn btn-outline-warning mt-5 mx-4 text-white"
                 data-toggle="button" aria-pressed="false" autocomplete="off">
                  Question 8
                </button>
                <button @click="routeToQuestion(8)"
                 type="button" class="btn btn-outline-primary mt-5 mx-4 text-white"
                 data-toggle="button" aria-pressed="false" autocomplete="off">
                  Question 9
                </button>
            </span >
    </div>

  </div>
</template>

<script>

import questions from '../func';

export default {
  name: 'HomeView',
  components: {
  },
  data() {
    return {
      questions,
    };
  },
  methods: {
    routeToQuestion(index) {
      this.$router.push({
        name: 'question',
        params: {
          id: index,
        },
      });
    },
  },
};
</script>

<style >
h2{
  /* font-weight: 700;
  font-size: 72px; */
  font-size: 2rem;
  margin-bottom: 0.5rem;
  font-family: "SF Pro Display","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;
  background: linear-gradient(121.57deg, #FFFFFF 18.77%, rgba(255, 255, 255, 0.66) 60.15%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* line-height: 72px; */
}
</style>
